// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"84bed1a1","48":"454b8d58","128":"a7e4a35a","163":"5053be8e","267":"a26bc7ed","345":"3b25e345","554":"e7f9cd59","650":"ea281281","867":"fcf6936a","926":"0ffa0362","990":"cee46b9d"}[chunkId] + ".chunk.js";
};